export default "__VITE_ASSET__CNaKTkwQ__"